import { controls } from './formParts/AdditionalFormCompensation'


export default function extractCompensationAdditional(formData: FormData): boolean {
  return !!formData.get(`${controls.homeschoolingOnly}`)
}
